import { render } from "./TaskCard.vue?vue&type=template&id=cf2e7f00&scoped=true"
import script from "./TaskCard.vue?vue&type=script&lang=ts"
export * from "./TaskCard.vue?vue&type=script&lang=ts"

import "./TaskCard.vue?vue&type=style&index=0&id=cf2e7f00&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-cf2e7f00"

export default script